import React, { useEffect } from 'react'
import TabComponent from '../../component/TabComponent'
import CoppyList from './coppyList'
import ItemSale from './itemSale'
import Promotion from './promotion'
import { SaleProvider } from './services/saleApi'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

export default function Sale() {
  const { profile } = useSelector(state => state.profile)
  const location = useLocation()
  const navigate = useNavigate()
  const dataTabs = [
    {
      title: 'ขายเมล็ดพันธุ์',
      page: <ItemSale />,
      url: '/sale/item-sale',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Sale.Create')?.Permit
    },
    {
      title: 'รายการขายเมล็ดพันธุ์',
      page: <CoppyList />,
      url: '/sale/coppy-list',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Sale.Read')?.Permit
    },
    {
      title: 'ตั้งราคาเฉพาะกิจ',
      page: <Promotion />,
      url: '/sale/promotion',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'Promotion.Read')?.Permit

    },
  ]
  useEffect(() => {
    if (location.pathname === '/sale') {
      navigate(dataTabs[0].url)
    }
  }, [location.pathname])
  return (
    <div style={{ padding: '10px 30px' }}>
      <SaleProvider>
        <TabComponent dataTabs={dataTabs} />
      </SaleProvider>
    </div>
  )
}
